"use client";

import styled from "styled-components";
import { spacing4, spacing8, spacing16, spacing24, spacing32, spacing48, spacing64, spacing128 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const gaps = {
  0: "0",
  4: spacing4,
  8: spacing8,
  16: spacing16,
  24: spacing24,
  32: spacing32,
  48: spacing48,
  64: spacing64,
  128: spacing128
};
const alignContentMap = {
  start: "start",
  center: "center",
  end: "end",
  normal: "normal"
};
const Container = styled.div.withConfig({
  componentId: "sc-3wjzbl-0"
})(["display:grid;grid-gap:", ";grid-auto-columns:100%;align-content:", ";"], ({
  $gapSize
}) => gaps[$gapSize], ({
  $align
}) => alignContentMap[$align]);

/**
 * Separates items with consistent spacing vertically.
 * @param {object} props - The component props
 * @param {React.ReactNode} [props.children] - Stack items
 * @param {"0" | "4" | "8" | "16" | "24" | "32" | "48" | "64" | "128"} [props.gapSize] - Gutter space between rows
 * @param {"start" | "center" | "end" | "normal"} [props.align] - How to align the items vertically in the stack
 * @returns {React.ReactNode} The Stack component
 */
const Stack = ({
  gapSize = "16",
  align = "normal",
  children,
  ...props
}) => /*#__PURE__*/_jsx(Container, {
  $gapSize: gapSize,
  $align: align,
  ...props,
  children: children
});
Stack.displayName = "Stack";
export default Stack;